/* eslint-disable quotes */
import { PayoutStatus } from './payouts.model';

export const PayoutStatusFilter = [
  {
    key: PayoutStatus.SUCCESS,
    value: 'Success'
  },
  {
    key: PayoutStatus.ON_HOLD,
    value: 'On hold'
  },
  {
    key: PayoutStatus.PENDING,
    value: 'In transit'
  }
];

export enum PayoutScheduleType {
  INSTANT = 'INSTANT',
  DAILY = 'DAILY',
  OFF = 'OFF'
}

export enum ConnectPayoutStatus {
  INITIATED = 'INITIATED',
  IN_TRANSIT = 'IN_TRANSIT',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  RETRYING = 'RETRYING',
  PAUSED = 'PAUSED',
  SCHEDULED = 'SCHEDULED'
}
export const connectPayoutStatusFilter = [
  {
    key: ConnectPayoutStatus.SUCCESS,
    value: 'Success'
  },
  {
    key: ConnectPayoutStatus.INITIATED,
    value: 'Initiated'
  },
  {
    key: ConnectPayoutStatus.IN_TRANSIT,
    value: 'In transit'
  },
  {
    key: ConnectPayoutStatus.CANCELLED,
    value: 'Cancelled'
  },
  {
    key: ConnectPayoutStatus.PAUSED,
    value: 'Paused'
  },
  {
    key: ConnectPayoutStatus.FAILED,
    value: 'Failed'
  }
];

export enum PayoutType {
  AUTO = 'AUTOMATIC',
  MANUAL = 'MANUAL'
}

export enum PaymentSystem {
  LIP = 'LIP',
  LBP = 'LBP',
  CA = 'CA',
  WA = 'WA'
}

export enum SettlementSystem {
  W2I = 'W2I'
}

export enum TIMELINE_EVENTS {
  INITIATED = 'INITIATED',
  IN_TRANSIT = 'IN_TRANSIT',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  RETRYING = 'RETRYING',
  PAUSED = 'PAUSED',
  EXPECTED_TO_ARRIVE = 'EXPECTED_TO_ARRIVE'
}

export enum PAYOUT_PANEL_PAGES {
  NOTES = 'NOTES',
  CONNECT_PAYOUT = 'CONNECT_PAYOUT',
  INSTANT_PAYOUT = 'INSTANT_PAYOUT',
  RECEIPT = 'RECEIPT'
}

export enum PAYOUT_TXNS_PAGES {
  FILTERS = 'FILTERS',
  PAYOUT_TXNS = 'PAYOUT_TXNS',
  HELD_IN_RESERVE = 'HELD_IN_RESERVE'
}

export enum PAYOUT_TXNS_TABS {
  PAYMENTS = 'PAYMENTS',
  ALL = 'ALL'
}

export enum PAYOUT_TXNS_HELD_IN_RESERVE_TABS {
  TO_BE_RELEASED = 'To be released',
  ALL = 'All'
}

export enum PAYOUT_TXNS_TYPE_FILTERS {
  COLLECTED = 'COLLECTED',
  REFUNDS = 'REFUNDS',
  ADJUSTMENTS = 'ADJUSTMENTS',
  FEES = 'FEES',
  ALL = 'ALL',
  CREDITS = 'CREDITS'
}

export enum PAYOUT_TXNS_AMOUNT_FILTERS {
  GREATER_THAN = 'Greater than',
  LESS_THAN = 'Less than',
  IN_BETWEEN = 'In between',
  EQUAL_TO = 'Equal to',
  ALL = 'All'
}

export const PAYOUT_TXNS_AMOUNT_FILTERS_ARRAY = [
  { title: PAYOUT_TXNS_AMOUNT_FILTERS.ALL },
  { title: PAYOUT_TXNS_AMOUNT_FILTERS.GREATER_THAN },
  { title: PAYOUT_TXNS_AMOUNT_FILTERS.LESS_THAN },
  { title: PAYOUT_TXNS_AMOUNT_FILTERS.IN_BETWEEN },
  { title: PAYOUT_TXNS_AMOUNT_FILTERS.EQUAL_TO }
];

export enum CTA_TYPES {
  URL = 'URL',
  DEEPLINK = 'DEEPLINK',
  POPUP = 'POPUP'
}

export enum PayoutRootPage {
  LIST = 'list',
  BALANCE = 'balance'
}

export enum EnablePayoutStatuses {
  NOT_STARTED = 'NOT_STARTED',
  STARTED_IN_PROGRESS = 'STARTED_IN_PROGRESS',
  SUBMITTED_IN_REVIEW = 'SUBMITTED_IN_REVIEW',
  SUBMITTED_NEED_MORE_PAYMENT_NOT_ALLOWED = 'SUBMITTED_NEED_MORE_PAYMENT_NOT_ALLOWED',
  SUBMITTED_NEED_MORE_PAYMENT_ALLOWED = 'SUBMITTED_NEED_MORE_PAYMENT_ALLOWED',
  APPROVED = 'APPROVED',
  APPROVED_CONDITIONAL = 'APPROVED_CONDITIONAL',
  REJECTED = 'REJECTED'
}

export enum ApplicationStatusPages {
  APPLICATION_STATUS = 'APPLICATION_STATUS',
  STRIPE_PENDING_DOC = 'STRIPE_PENDING_DOC'
}

export enum ActionNeededTypes {
  BANK = 'BANK',
  KYC = 'KYC'
}

export enum ConnectBankStatuses {
  SUBMITTED = 'SUBMITTED',
  NOT_SUBMITTED = 'NOT_SUBMITTED'
}

export enum InternalBankStatuses {
  FINANCIAL_DATA_NOT_SUBMITTED = 'FINANCIAL_DATA_NOT_SUBMITTED',
  FINANCIAL_DATA_SUBMITTED = 'FINANCIAL_DATA_SUBMITTED',
  FINANCIAL_DATA_VERIFIED = 'FINANCIAL_DATA_VERIFIED',
  FINANCIAL_DATA_REJECTED = 'FINANCIAL_DATA_REJECTED'
}

export enum BankAccountCardType {
  ADD_BANK_ACCOUNT = ' ADD_BANK_ACCOUNT',
  ADD_ANOTHER_BANK_ACCOUNT = 'ADD_ANOTHER_BANK_ACCOUNT',
  ACTION_NEEDED = 'ACTION_NEEDED',
  VERIFICATION_IN_PROGRESS = 'VERIFICATION_IN_PROGRESS'
}

export enum HeldInReserveStatus {
  ALL = 'ALL',
  HELD = 'HELD',
  RELEASED = 'RELEASED'
}

export const HELD_IN_RESERVE_DATE_OPTIONS = {
  CREATED: {
    ALL: 'All',
    LAST_7_DAYS: 'Last 7 days',
    LAST_1_MONTH: 'Last 1 month',
    LAST_6_MONTHS: 'Last 6 months',
    DATE_RANGE: 'Date range'
  },
  AVAILABLE: {
    ALL: 'All',
    NEXT_7_DAYS: 'Next 7 days',
    NEXT_1_MONTH: 'Next 1 month',
    NEXT_6_MONTHS: 'Next 6 months',
    DATE_RANGE: 'Date range'
  }
};

export const CHANGE_BANK_ACTION_REQUIRED_PAUSE_DESC =
  'You are trying to connect a new bank account. Until you finish this process, your payouts will be paused.';

export const CHANGE_BANK_ACTION_REQUIRED_PAUSE_DESC_NON_OWNER =
  'Your payouts are paused. Contact your owner to complete connecting the new bank account.';

export const CHANGE_BANK_IN_REVIEW_PAUSE_DESC =
  'You have submitted a new bank account to be connected. We are reviewing your application. ' +
  'Usually takes 1 to 2 business days.';

export const WA_RECONNECT_PAUSE_DESC =
  'Your payouts are currently paused. Please re-enter your bank details to resume payouts.';

export const WA_RECONNECT_PAUSE_DESC_NON_OWNER = 'Your payouts are currently paused. Please contact your owner';

export const WA_RECONNECT_PAUSE_CTA = 'Re-enter bank details';

export const BANK_NOT_LINKED_PAUSE_DESC = 'Complete verification to start receiving payouts.';

export const REJECTED_BANK_PAUSE_DESC = 'Your payouts will be scheduled once you have linked your bank account.';

export const CHANGE_BANK_ACCOUNT_CTA = 'Change bank account';

export const VERIFICATION_ACTION_NEEDED_TITLE = 'Action needed to complete verification';

export const VERIFICATION_ACTION_NEEDED_DESC = 'Payouts will be enabled automatically once verification is complete.';

export const KYC_COMPLETE_VERIFICATION_CTA = 'Complete verification';

export const RISK_SUBMIT_ADDITIONAL_DATA_CTA = 'Submit additional data';

export const RISK_REVIEW_IN_PROGRESS_DESC = "Your verification is in review. Payouts start once you're approved.";

export const RISK_HOLD_DESC =
  'Your payouts are being processed automatically. Part of your payments is held temporarily ' +
  'as part of our standard payment review and is released automatically on a rolling schedule.';

export const GENERIC_PAUSE_DESC =
  'Your payouts are currently paused. Please email us at support@goscanpay.com for more details.';

export const NEGATIVE_PO_PAUSE_DESC =
  'Your payouts are temporarily paused for 3 days due to a debit pull on your account. ' +
  'View Upcoming Payouts for your next scheduled payout.';

/** GET /merchants/messages key for [NEGATIVE_PO_PAUSE_DESC]. */
export const PAYOUTS_PAUSED_DEBIT_PULL_MESSAGE_KEY = 'PAYOUTS_PAUSED_DEBIT_PULL';

export const COMPLETE_BANK_VERIFICATION_CTA = 'Complete bank verification';
